import { defaultTo } from 'ramda';
import { IServicesUnavailableMessage } from '../../../redux/reducers';
import { ICheckServiceMessageSchema } from '../../../repositories/monolith-python/entities/CheckServiceMessageSchema';

export function mapServicesUnavailableMessage(
  servicesUnavailableMessage?: ICheckServiceMessageSchema | null,
): IServicesUnavailableMessage | null {
  if (!servicesUnavailableMessage) {
    return null;
  }

  const { body, header } = servicesUnavailableMessage;

  return {
    body: defaultTo('', body),
    header: defaultTo('', header),
  };
}
